"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _ProfileIntegrationsAction = _interopRequireDefault(require("crm_ui/profile/sidebar/integrations/actions/ProfileIntegrationsAction"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _default = (0, _createReactClass.default)({
  displayName: 'ProfileIntegrationsActionsList',
  propTypes: {
    actions: _propTypes.default.instanceOf(_immutable.List).isRequired,
    applicationId: _propTypes.default.number.isRequired,
    appName: _propTypes.default.string.isRequired,
    associatedObjectId: _propTypes.default.number.isRequired,
    associatedObjectType: _propTypes.default.oneOf([_ObjectTypes.CONTACT, _ObjectTypes.COMPANY, _ObjectTypes.DEAL]).isRequired,
    buttonClassName: _propTypes.default.string,
    buttonSize: _propTypes.default.string,
    buttonText: _propTypes.default.string,
    buttonUse: _propTypes.default.string,
    closeIframeModal: _propTypes.default.func.isRequired,
    dropdownButtonUse: _propTypes.default.string,
    iconName: _propTypes.default.string,
    iframeParentTitle: _propTypes.default.string.isRequired,
    objectId: _propTypes.default.number,
    objectTypeId: _propTypes.default.number.isRequired,
    openIframeModal: _propTypes.default.func.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      buttonSize: 'default',
      buttonUse: 'default'
    };
  },
  renderActions: function renderActions() {
    var actions = this.props.actions;
    return actions.map(this.renderAction);
  },
  renderAction: function renderAction(action) {
    var _this$props = this.props,
        associatedObjectId = _this$props.associatedObjectId,
        associatedObjectType = _this$props.associatedObjectType,
        applicationId = _this$props.applicationId,
        appName = _this$props.appName,
        closeIframeModal = _this$props.closeIframeModal,
        dropdownButtonUse = _this$props.dropdownButtonUse,
        iframeParentTitle = _this$props.iframeParentTitle,
        objectId = _this$props.objectId,
        objectTypeId = _this$props.objectTypeId,
        openIframeModal = _this$props.openIframeModal;
    return _react.default.createElement(_ProfileIntegrationsAction.default, {
      action: action,
      applicationId: applicationId,
      appName: appName,
      associatedObjectId: associatedObjectId,
      associatedObjectType: associatedObjectType,
      buttonUse: dropdownButtonUse,
      closeIframeModal: closeIframeModal,
      key: action.get('label'),
      iframeParentTitle: iframeParentTitle,
      objectId: objectId,
      objectTypeId: objectTypeId,
      openIframeModal: openIframeModal
    });
  },
  render: function render() {
    var _this$props2 = this.props,
        buttonSize = _this$props2.buttonSize,
        buttonText = _this$props2.buttonText,
        buttonUse = _this$props2.buttonUse,
        buttonClassName = _this$props2.buttonClassName,
        iconName = _this$props2.iconName;
    return _react.default.createElement(_UIDropdown.default, {
      buttonClassName: buttonClassName,
      buttonSize: buttonSize,
      buttonText: buttonText,
      buttonUse: buttonUse,
      iconName: iconName
    }, _react.default.createElement(_UIList.default, null, this.renderActions()));
  }
});

exports.default = _default;
module.exports = exports.default;